import { MenuItem } from './menu-item';
import { ConfigConta } from './types';

const DIVISION_BADGE = 'Divisões';
const UNIT_BADGE = 'Unidades';

/**
 * Troca o `badgeClass` `'Divisões'`/`'Unidades'` pelos nomes configurados na
 * conta. Espelha `prepararNomesUnidadeEDivisao`; percorre submenus
 * recursivamente por robustez, ainda que o Angular só aplique no nível raiz.
 */
export function applyDivisionUnitLabels(
  tree: readonly MenuItem[],
  config: ConfigConta | null,
): MenuItem[] {
  return tree.map((item) => {
    const submenu =
      item.submenu.length > 0 ? applyDivisionUnitLabels(item.submenu, config) : item.submenu;
    const badgeClass = resolveBadgeClass(item.badgeClass, config);

    return badgeClass === item.badgeClass && submenu === item.submenu
      ? item
      : { ...item, badgeClass, submenu };
  });
}

function resolveBadgeClass(badgeClass: string, config: ConfigConta | null): string {
  if (badgeClass === DIVISION_BADGE && config?.divisao) {
    return config.divisao;
  }

  if (badgeClass === UNIT_BADGE && config?.unidade) {
    return config.unidade;
  }

  return badgeClass;
}
